import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  
  palette: {
    // mode: 'dark',
    primary: {
      main: '#607d8b',
    },
    secondary: {
      main: '#e91e63',
    },
    error: {
      main: red.A400,
    },
  },
  components: {
    
  }
});


export default theme;